'use client'

import React, { useEffect, useMemo } from 'react'
import { NumericFormat } from 'react-number-format'

import { normalizeErrorSimple } from '@rewardops/utils/src/form-utils'

import { cn } from '../lib/utils'
import { inputVariants, Label } from '../shad'
import { type InputFieldProps } from './input-field'

const NumberField = ({
  name,
  label,
  disabled,
  type = 'text',
  className,
  formConsts,
  initialValue,
  registerOptions = {},
  thousandSeparator = ',',
  maxLength,
  ...props
}: InputFieldProps & { thousandSeparator?: string; maxLength?: number }) => {
  const error = normalizeErrorSimple(name, formConsts?.errors?.[name]?.message)

  const field = useMemo(() => {
    return { ...formConsts?.register(name, registerOptions) }
  }, [formConsts, name, registerOptions])

  useEffect(() => {
    field.onChange({ target: { name, value: initialValue } })
  }, [name])

  return (
    <div className={cn('mb-3 w-full', { hidden: type === 'hidden' })}>
      <div className="h-full w-full items-center">
        <Label htmlFor={name}>{label}</Label>

        <NumericFormat
          className={cn(
            inputVariants(),
            {
              'border border-l-0 border-r-0 border-red-500': error,
            },
            className,
          )}
          {...props}
          defaultValue={initialValue}
          allowNegative={false}
          thousandSeparator={thousandSeparator}
          onValueChange={({ value }) => {
            // Convert to a pseudo event
            field.onChange({ target: { name, value } })
          }}
          maxLength={maxLength}
        />
        {error ? (
          <p className="px-1 text-xs text-red-600">{error}</p>
        ) : undefined}
      </div>
    </div>
  )
}

export { NumberField }
